ACC.cart = {

    _autoload: [
        'bindHelp',
        'cartRestoration',
        'bindCartPage',
        'bindMultiDEntryRemoval',
        'bindMultidCartProduct',
        ['bindApplyVoucher', $('#js-voucher-apply-btn').length !== 0],
        ['bindToReleaseVoucher', $('#js-applied-vouchers').length !== 0],
        ['bindQuoteCreate', $('.js-create-quote-button').length !== 0],
        ['bindApplyPostalCode', $('#js-apply-postal-code-btn').length !== 0],
    ],

    bindHelp() {
        $(document).on('click', '.js-cart-help', function (e) {
            e.preventDefault();
            const title = $(this).data('help');
            ACC.colorbox.open(title, {
                html: $('.js-help-popup-content').html(),
            });
        });
    },

    cartRestoration() {
        $('.cartRestoration').click(function () {
            const sCartUrl = $(this).data('cartUrl');
            window.location = sCartUrl;
        });
    },

    bindCartPage() {
        // link to display the multi-d grid in read-only mode
        $(document).on('click', '.js-show-editable-grid', function (event) {
            ACC.cart.populateAndShowEditableGrid(this, event);
        });
    },

    bindMultiDEntryRemoval() {
        $(document).on('click', '.js-submit-remove-product-multi-d', function () {
            const itemIndex = $(this).data('index');
            const $form = $(`#updateCartForm${itemIndex}`);
            const initialCartQuantity = $form.find('input[name=initialQuantity]');
            const cartQuantity = $form.find('input[name=quantity]');
            // eslint-disable-next-line no-unused-vars
            const entryNumber = $form.find('input[name=entryNumber]').val();
            // eslint-disable-next-line no-unused-vars
            const productCode = $form.find('input[name=productCode]').val();

            cartQuantity.val(0);
            initialCartQuantity.val(0);

            const method = $form.attr('method') ? $form.attr('method').toUpperCase() : 'GET';
            $.ajax({
                url: $form.attr('action'),
                data: $form.serialize(),
                type: method,
                // eslint-disable-next-line no-unused-vars
                success(data) {
                    // eslint-disable-next-line no-restricted-globals
                    location.reload();
                },
                error(xht, textStatus, ex) {
                    // eslint-disable-next-line no-alert
                    alert(`Failed to remove quantity. Error details [${xht}, ${textStatus}, ${ex}]`);
                },
            });
        });
    },

    // eslint-disable-next-line no-unused-vars
    populateAndShowEditableGrid(element, event) {
        const readOnly = $(element).data('readOnlyMultidGrid');
        const itemIndex = $(element).data('index');
        // eslint-disable-next-line no-undef
        grid = $(`#ajaxGrid${itemIndex}`);

        const gridEntries = $(`#grid${itemIndex}`);
        const strSubEntries = gridEntries.data('sub-entries');
        const arrSubEntries = strSubEntries.split(',');
        const firstVariantCode = arrSubEntries[0].split(':')[0];

        $(element).toggleClass('open');

        const targetUrl = gridEntries.data('target-url');

        // eslint-disable-next-line no-new-object
        const mapCodeQuantity = new Object();
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < arrSubEntries.length; i++) {
            const arrValue = arrSubEntries[i].split(':');
            // eslint-disable-next-line prefer-destructuring
            mapCodeQuantity[arrValue[0]] = arrValue[1];
        }

        // eslint-disable-next-line no-undef
        if (grid.children('#cartOrderGridForm').length > 0) {
            // eslint-disable-next-line no-undef
            grid.slideToggle('slow');
        } else {
            const method = 'GET';
            $.ajax({
                url: targetUrl,
                data: { productCode: firstVariantCode, readOnly },
                type: method,
                success(data) {
                    // eslint-disable-next-line no-undef
                    grid.html(DOMPurify.sanitize(data));
                    $('#ajaxGrid').removeAttr('id');
                    // eslint-disable-next-line no-undef
                    const $gridContainer = grid.find('.product-grid-container');
                    const numGrids = $gridContainer.length;
                    // eslint-disable-next-line no-plusplus
                    for (let i = 0; i < numGrids; i++) {
                        ACC.cart.getProductQuantity($gridContainer.eq(i), mapCodeQuantity, i);
                    }
                    // eslint-disable-next-line no-undef
                    grid.slideDown('slow');
                    ACC.cart.coreCartGridTableActions(element, mapCodeQuantity);
                    // eslint-disable-next-line no-undef
                    ACC.productorderform.coreTableScrollActions(grid.children('#cartOrderGridForm'));
                },
                error(xht, textStatus, ex) {
                    // eslint-disable-next-line no-alert
                    alert(`Failed to get variant matrix. Error details [${xht}, ${textStatus}, ${ex}]`);
                },
            });
        }
    },

    coreCartGridTableActions(element, mapCodeQuantity) {
        ACC.productorderform.bindUpdateFutureStockButton('.update_future_stock_button');
        ACC.productorderform.bindVariantSelect($('.variant-select-btn'), 'cartOrderGridForm');
        const itemIndex = $(element).data('index');
        const skuQuantityClass = '.sku-quantity';

        let quantityBefore = 0;
        const grid = $(`#ajaxGrid${itemIndex} .product-grid-container`);

        grid.on('focusin', skuQuantityClass, function () {
            quantityBefore = jQuery.trim(this.value);

            $(this).parents('tr').next('.variant-summary').remove();
            if ($(this).parents('table').data(ACC.productorderform.selectedVariantData)) {
                // eslint-disable-next-line max-len
                ACC.productorderform.selectedVariants = $(this).parents('table').data(ACC.productorderform.selectedVariantData);
            } else {
                ACC.productorderform.selectedVariants = [];
            }

            if (quantityBefore === '') {
                quantityBefore = 0;
                this.value = 0;
            }
        });

        grid.on('focusout keypress', skuQuantityClass, function (event) {
            const code = event.keyCode || event.which || event.charCode;

            if (code !== 13 && code !== undefined) {
                return;
            }

            let quantityAfter = 0;
            let gridLevelTotalPrice = '';

            const indexPattern = '[0-9]+';
            // eslint-disable-next-line radix
            const currentIndex = parseInt($(this).attr('id').match(indexPattern));

            this.value = ACC.productorderform.filterSkuEntry(this.value);

            quantityAfter = jQuery.trim(this.value);
            const variantCode = $(`input[id='cartEntries[${currentIndex}].sku']`).val();

            // eslint-disable-next-line no-restricted-globals
            if (isNaN(jQuery.trim(this.value))) {
                this.value = 0;
            }

            if (quantityAfter === '') {
                quantityAfter = 0;
                this.value = 0;
            }

            const $gridTotalValue = grid.find(`[data-grid-total-id=total_value_${currentIndex}]`);
            const currentPrice = $(`input[id='productPrice[${currentIndex}]']`).val();

            if (quantityAfter > 0) {
                // eslint-disable-next-line max-len
                gridLevelTotalPrice = ACC.productorderform.formatTotalsCurrency(parseFloat(currentPrice) * parseInt(quantityAfter, 10));
            }

            $gridTotalValue.html(gridLevelTotalPrice);

            const _this = this;
            const priceSibling = $(this).siblings('.price');
            const propSibling = $(this).siblings('.variant-prop');
            const currentSkuId = $(this).next('.td_stock').data('sku-id');
            const currentBaseTotal = $(this).siblings('.data-grid-total');

            if (this.value !== quantityBefore) {
                let newVariant = true;
                ACC.productorderform.selectedVariants.forEach((item, index) => {
                    if (item.id === currentSkuId) {
                        newVariant = false;

                        if (_this.value === '0' || _this.value === 0) {
                            ACC.productorderform.selectedVariants.splice(index, 1);
                        } else {
                            ACC.productorderform.selectedVariants[index].quantity = _this.value;
                            // eslint-disable-next-line max-len
                            ACC.productorderform.selectedVariants[index].total = ACC.productorderform.updateVariantTotal(priceSibling, _this.value, currentBaseTotal);
                        }
                    }
                });

                if (newVariant && this.value > 0) {
                    // update variantData
                    ACC.productorderform.selectedVariants.push({
                        id: currentSkuId,
                        size: propSibling.data('variant-prop'),
                        quantity: _this.value,
                        total: ACC.productorderform.updateVariantTotal(priceSibling, _this.value, currentBaseTotal),
                    });
                }
            }
            ACC.productorderform.showSelectedVariant($(this).parents('table'));
            if (this.value > 0 && this.value !== quantityBefore) {
                $(this).parents('table').addClass('selected');
            } else {
                // eslint-disable-next-line no-lonely-if
                if (ACC.productorderform.selectedVariants.length === 0) {
                    // eslint-disable-next-line newline-per-chained-call
                    $(this).parents('table').removeClass('selected').find('.variant-summary').remove();
                }
            }

            if (quantityBefore !== quantityAfter) {
                const method = 'POST';
                $.ajax({
                    url: `${ACC.config.encodedContextPath}/cart/updateMultiD`,
                    data: { productCode: variantCode, quantity: quantityAfter, entryNumber: -1 },
                    type: method,
                    // eslint-disable-next-line no-unused-vars
                    success(data, textStatus, xhr) {
                        ACC.cart.refreshCartData(data, -1, quantityAfter, itemIndex);
                        // eslint-disable-next-line no-param-reassign
                        mapCodeQuantity[variantCode] = quantityAfter;
                    },
                    // eslint-disable-next-line no-unused-vars
                    error(xhr, textStatus, error) {
                        const redirectUrl = xhr.getResponseHeader('redirectUrl');
                        const connection = xhr.getResponseHeader('Connection');
                        // check if error leads to a redirect
                        if (redirectUrl !== null) {
                            window.location = redirectUrl;
                            // check if error is caused by a closed connection
                        } else if (connection === 'close') {
                            window.location.reload();
                        }
                    },
                });
            }
        });
    },

    refreshCartData(cartData, entryNum, quantity, itemIndex) {
        // if cart is empty, we need to reload the whole page
        if (cartData.entries.length === 0) {
            // eslint-disable-next-line no-restricted-globals
            location.reload();
        } else {
            let form;

            // eslint-disable-next-line eqeqeq
            if (entryNum == -1) { // grouped item
                form = $(`.js-qty-form${itemIndex}`);
                const productCode = form.find('input[name=productCode]').val();

                // eslint-disable-next-line no-shadow
                let quantity = 0;
                let entryPrice = 0;
                // eslint-disable-next-line no-plusplus
                for (let i = 0; i < cartData.entries.length; i++) {
                    const entry = cartData.entries[i];
                    // eslint-disable-next-line eqeqeq
                    if (entry.product.code == productCode) {
                        // eslint-disable-next-line no-param-reassign
                        quantity = entry.quantity;
                        entryPrice = entry.totalPrice;
                        ACC.cart.updateEntryNumbersForCartMenuData(entry);
                        break;
                    }
                }

                if (quantity === 0) {
                    // eslint-disable-next-line no-restricted-globals
                    location.reload();
                } else {
                    form.find('.qtyValue').html(quantity);
                    form.parent().parent().find('.js-item-total').html(entryPrice.formattedValue);
                }
            }

            ACC.cart.refreshCartPageWithJSONResponse(cartData);
        }
    },

    refreshCartPageWithJSONResponse(cartData) {
        // refresh mini cart
        ACC.minicart.updateMiniCartDisplay();
        $('.js-cart-top-totals').html($('#cartTopTotalSectionTemplate').tmpl(cartData));
        $('div .cartpotproline').remove();
        $('div .cartproline').remove();
        $('.js-cart-totals').remove();
        $('#ajaxCartPotentialPromotionSection').html($('#cartPotentialPromotionSectionTemplate').tmpl(cartData));
        $('#ajaxCartPromotionSection').html($('#cartPromotionSectionTemplate').tmpl(cartData));
        $('#ajaxCart').html($('#cartTotalsTemplate').tmpl(cartData));
        ACC.quote.bindQuoteDiscount();
    },

    updateEntryNumbersForCartMenuData(entry) {
        let entryNumbers = '';
        $.each(entry.entries, (index, subEntry) => {
            if (index !== 0) {
                entryNumbers = `${entryNumbers};`;
            }
            entryNumbers += subEntry.entryNumber;
        });
        $('.js-execute-entry-action-button').data('actionEntryNumbers', entryNumbers);
    },

    // eslint-disable-next-line no-unused-vars
    getProductQuantity(gridContainer, mapData, i) {
        const tables = gridContainer.find('table');

        $.each(tables, (index, currentTable) => {
            const skus = jQuery.map($(currentTable).find("input[type='hidden'].sku"), (o) => o.value);
            const quantities = jQuery.map($(currentTable).find("input[type='textbox'].sku-quantity"), (o) => o);
            const selectedVariants = [];

            // eslint-disable-next-line no-shadow
            $.each(skus, (index, skuId) => {
                const quantity = mapData[skuId];
                if (quantity !== undefined) {
                    quantities[index].value = quantity;
                    const indexPattern = '[0-9]+';
                    // eslint-disable-next-line radix
                    const currentIndex = parseInt(quantities[index].id.match(indexPattern));
                    // eslint-disable-next-line max-len
                    const gridTotalValue = gridContainer.find(`[data-grid-total-id=total_value_${currentIndex}]`);
                    let gridLevelTotalPrice = '';
                    const currentPrice = $(`input[id='productPrice[${currentIndex}]']`).val();
                    if (quantity > 0) {
                        // eslint-disable-next-line max-len
                        gridLevelTotalPrice = ACC.productorderform.formatTotalsCurrency(parseFloat(currentPrice) * parseInt(quantity, 10));
                    }
                    gridTotalValue.html(gridLevelTotalPrice);
                    selectedVariants.push({
                        id: skuId,
                        size: $(quantities[index]).siblings('.variant-prop').data('variant-prop'),
                        quantity,
                        total: gridLevelTotalPrice,
                    });
                }
            });

            if (selectedVariants.length !== 0) {
                $.tmpl(ACC.productorderform.$variantSummaryTemplate, {
                    variants: selectedVariants,
                }).appendTo($(currentTable).addClass('selected'));
                // eslint-disable-next-line max-len
                $(currentTable).find('.variant-summary .variant-property').html($(currentTable).find('.variant-detail').data('variant-property'));
                $(currentTable).data(ACC.productorderform.selectedVariantData, selectedVariants);
            }
        });
    },

    bindMultidCartProduct() {
        // link to display the multi-d grid in read-only mode
        $(document).on('click', '.showQuantityProduct', function (event) {
            ACC.multidgrid.populateAndShowGrid(this, event, true);
        });

        // link to display the multi-d grid in read-only mode
        $(document).on('click', '.showQuantityProductOverlay', function (event) {
            ACC.multidgrid.populateAndShowGridOverlay(this, event);
        });
    },

    bindApplyVoucher() {
        $(document).ready(() => {
            const helpMessageElem = document.querySelector('#help-block-message');
            const inputElem = document.querySelector('#js-voucher-code-text');
            const removeButton = document.querySelector('.js-release-voucher-remove-btn');

            if (!helpMessageElem) {
                return;
            }

            if (helpMessageElem.classList.contains('help-block__error')) {
                inputElem.focus();
                inputElem.select();
            } else if (removeButton) {
                removeButton.focus();
            }
        });

        $('#js-voucher-apply-btn').on('click', (e) => {
            ACC.cart.handleApplyVoucher(e);
        });
    },

    // eslint-disable-next-line no-unused-vars
    handleApplyVoucher(e) {
        const voucherCode = $.trim($('#js-voucher-code-text').val());
        if (voucherCode !== '' && voucherCode.length > 0) {
            sessionStorage.removeItem('isPromocodeRemoved');
            $('#applyVoucherForm').submit();
        }
    },

    validateEmptyInput(btn) {
        let empty = false;

        if ($(this).val().trim() === '') { empty = true; }

        if (empty) {
            btn.attr('disabled', 'disabled');
        } else {
            btn.removeAttr('disabled');
        }
    },

    bindApplyPostalCode() {
        const btn = $('#js-apply-postal-code-btn');
        const input = $('#js-cart-apply-postal-code-text');
        const formPostalCode = $('#applyCartPostalCode');
        const component = $('.c-cart-tax');

        // Validate input
        input.on('input', function () {
            ACC.cart.validateEmptyInput.call(this, btn);
        });
        formPostalCode.on('submit', function (e) {
            e.preventDefault();
            // Prevent many ajax calls
            btn.attr('disabled', 'disabled');

            const form = $(this);
            const postalCode = $.trim(input.val());

            $.ajax({
                url: ACC.config.encodedContextPath + form.attr('action'),
                data: { postalCode },
                type: form.attr('method'),
                // eslint-disable-next-line no-unused-vars
                success(data, response) {
                    const responseData = data;
                    const zipCodeMsg = component.find('#zip-code-message');
                    const toggleBlockArea = component.find('.toggle-block-area');
                    const toggleBlockOpener = component.find('.toggle-block-opener');
                    if (responseData.validationResult !== null) {
                        if (ACC.utils.isHedTheme()) {
                            // eslint-disable-next-line no-undef
                            zipCodeMsg.html(DOMPurify.sanitize(responseData.validationResult));
                            zipCodeMsg.removeClass('help-block__success');
                            zipCodeMsg.addClass('help-block__error');
                            input.attr('aria-invalid', 'true');
                            input.focus();
                        } else {
                            component.find('.help-block__error')
                                // eslint-disable-next-line no-undef
                                .html(DOMPurify.sanitize(responseData.validationResult));
                        }
                        component.addClass('has-error active');
                    } else {
                        if (ACC.utils.isHedTheme()) {
                            component.removeClass('has-error active');
                            zipCodeMsg.removeClass('help-block__error');
                            zipCodeMsg.addClass('help-block__success');
                            zipCodeMsg.html('Zip code applied');
                            input.attr('aria-invalid', 'false');
                            toggleBlockOpener[0].setAttribute('aria-expanded', 'false');
                            toggleBlockOpener.focus();
                        } else {
                            component.removeClass('has-error active');
                            zipCodeMsg.removeClass('help-block__success');
                            zipCodeMsg.addClass('help-block__error');
                        }
                        component.find('.c-cart-tax__wrap').addClass('is-estimated');
                        toggleBlockArea.slideUp();
                        component.find('.c-cart-tax__text-label').html('Edit');
                        component.find('.c-cart-tax__title').html('Estimated Tax for');
                        // eslint-disable-next-line no-undef
                        component.find('.c-cart-tax__estimated-tax').html(DOMPurify.sanitize(responseData.totalTax));
                        // eslint-disable-next-line no-undef
                        component.find('.c-cart-tax__postal-code').html(DOMPurify.sanitize(responseData.postalCode));
                        if (ACC.utils.isHedTheme()) {
                            const taxZip = [responseData.postalCode, responseData.totalTax].join(' is ');
                            component.find('#postalCode').attr('aria-label', `Estimated Tax for ${taxZip} edit ZIP`);
                        }
                        $('.js-cart-totals').find('.js-total-price')
                            // eslint-disable-next-line no-undef
                            .html(DOMPurify.sanitize(responseData.totalPriceWithTax));
                    }
                    btn.removeAttr('disabled');
                },
                error(response) {
                    if (ACC.utils.isHedTheme()) {
                        const zipCodeMsg = component.find('#zip-code-message');
                        // eslint-disable-next-line no-undef
                        zipCodeMsg.html(DOMPurify.sanitize(response.responseText));
                        zipCodeMsg.removeClass('help-block__success');
                        zipCodeMsg.addClass('help-block__error');
                    } else {
                        // eslint-disable-next-line no-undef
                        component.find('.help-block__error').html(DOMPurify.sanitize(response.responseText));
                    }
                    btn.removeAttr('disabled');
                },
            });
        });
    },

    handleRemoveVoucher(url, data) {
        $.ajax({
            url,
            data,
            type: 'POST',
            success(response) {
                sessionStorage.setItem('isPromocodeRemoved', 'true');

                if (response.redirected) {
                    window.location.href = response.url;
                }

                const helpBlock = $('.js-voucher-validation-container');
                const removeInput = $('.c-cart-voucher__applied');
                const holder = $('.toggle-block');
                const slide = holder.find('.toggle-block-area');
                const btn = holder.find('.toggle-block-opener');
                const inputVoucherCode = holder.find('.js-voucher-code');

                if (holder && slide && btn) {
                    ACC.cartitem.clickHandler(holder, slide, btn);
                }

                if (btn) {
                    btn.focus();
                }

                if (helpBlock) {
                    helpBlock.remove();
                }

                if (holder.hasClass('has-error')) {
                    holder.removeClass('has-error');
                    inputVoucherCode.val('');
                }

                removeInput.remove();
            },
            error(err) {
                console.log(err);
                // eslint-disable-next-line no-restricted-globals
                location.reload();
            },
        });
    },

    checkWasPromocodeRemoved(promocodeButtonElem) {
        const isPromocodeRemoved = sessionStorage.getItem('isPromocodeRemoved');

        if (isPromocodeRemoved) {
            sessionStorage.removeItem('isPromocodeRemoved');
            promocodeButtonElem.focus();
        }
    },

    bindToReleaseVoucher() {
        if (ACC.utils.isHedTheme()) {
            const promocodeButtonElem = document.querySelector('#promoCode');

            $(document).ready(() => this.checkWasPromocodeRemoved(promocodeButtonElem));

            $(document).on('submit', '.c-cart-voucher__form-remove', function (e) {
                e.preventDefault();
                const form = $(this).closest('form');
                const url = form.attr('action');
                ACC.cart.handleRemoveVoucher(url, form.serialize());
            });
        } else {
            $('.js-release-voucher-remove-btn').on('click', function () {
                $(this).closest('form').submit();
            });
        }
    },

    // eslint-disable-next-line no-unused-vars
    bindQuoteCreate(e) {
        ACC.cart.handlePromotionModal({
            actionButtonSelector: '.js-create-quote-button',
            modalWindowSelector: '#js-quote-promotion-modal',
            modalTitleDataAttributeName: 'quote-modal-title',
            actionButtonUrlDataAttributeName: 'target-url',
            actionButtonCustomerUrlDataAttributeName: 'update-customer-url',
            modalExpirationDataAttributeName: 'quote-promotion-expiration',
            cancelButtonSelector: '#js-quote-promotion-modal #cancelButton',
            continueButtonSelector: '#js-quote-promotion-modal #continueButton',
        });
    },

    handlePromotionModal(options) {
        const modalWindow = $(options.modalWindowSelector);
        const targetUrl = $(options.actionButtonSelector).data(options.actionButtonUrlDataAttributeName);
        // eslint-disable-next-line max-len
        const updateCustomerUrl = $(options.actionButtonSelector).data(options.actionButtonCustomerUrlDataAttributeName);

        $(options.actionButtonSelector).click(function (e) {
            e.preventDefault();
            const expiration = modalWindow.data(options.modalExpirationDataAttributeName);
            if (expiration) {
                if (options.initializeCallback) {
                    options.initializeCallback();
                }
                $modal.open(this);
            } else {
                ACC.checkout.processCheckoutRequest(targetUrl, updateCustomerUrl);
            }
        });

        $(options.cancelButtonSelector).click($modal.close);

        $(options.continueButtonSelector).click((event) => {
            event.preventDefault();
            $modal.close();
            ACC.checkout.processCheckoutRequest(targetUrl, updateCustomerUrl);
        });
    },
};
